// src/services/api.ts
import axios from 'axios'
import { API_URL } from '../api/config'
import { instalarEscopoDeEvento } from '../api/eventScope'

const api = axios.create({
  baseURL: API_URL,
});

// Escopo de evento e teto de espera em todas as chamadas, sem tocar nos call sites.
instalarEscopoDeEvento(api);

export default api;
